import clsx from 'clsx';

import useTranslation from '@/utils/hooks/translation/useTranslation';

import PropTypes from 'prop-types';

// Components
import Icon from '@/components/base/Icon';
import Tooltip from '@/components/base/Tooltip';

const FiltersSide = ({
    isOpen = false,
    toggleFilters = () => {
        /** */
    },
    onResetFilters = () => {
        /** */
    },
    children,
    className
}) => {
    const { t } = useTranslation('commons');
    return (
        <aside
            className={clsx(
                'relative flex w-full shrink flex-col',
                { hidden: !isOpen },
                '@xl/wrapper-platform-content:ml-5 @xl/wrapper-platform-content:w-80',
                className
            )}>
            <div className="min-h-full w-full rounded-md bg-white dark:bg-icoDarkMode-anthracite">
                <div className="flex justify-between border-b border-icoGray-300 p-5 dark:border-icoDarkMode-beton">
                    <div className="flex items-center space-x-3">
                        <Icon icon="filter" className="text-icoBlue" />
                        <span>{t('filters')}</span>
                    </div>
                    <div className="flex flex-row items-center space-x-2">
                        <Tooltip content={t('myprofile:reset_filters')}>
                            <button
                                aria-label={t('myprofile:reset_filters')}
                                className="leading-none text-icoGray-400 dark:text-icoDarkMode-wolf"
                                onClick={onResetFilters}>
                                <Icon icon="refresh" className="align-bottom" />
                            </button>
                        </Tooltip>
                        <button
                            aria-label="filter-close-button"
                            className="h-4 w-4 rounded-full bg-icoGray-300 text-xs leading-none text-icoGray-400 dark:bg-icoDarkMode-beton dark:text-icoDarkMode-wolf"
                            onClick={toggleFilters}>
                            <Icon icon="close" className="align-bottom" />
                        </button>
                    </div>
                </div>
                <div className="space-y-8 p-5">{children}</div>
            </div>
        </aside>
    );
};

FiltersSide.propTypes = {
    isOpen: PropTypes.bool,
    toggleFilters: PropTypes.func,
    onResetFilters: PropTypes.func
};

export default FiltersSide;
